import {
  createRouter,
  createWebHistory,
  type NavigationGuardWithThis,
  type RouteRecordRaw,
} from 'vue-router';

import Home from './views/Home.vue';
import Callback from './views/Callback.vue';
import Profile from './views/Profile.vue';
import Dashboard from './views/Dashboard.vue';
import Servicepartner from './views/Servicepartner.vue';
import ErrorPatterns from './views/ErrorPatterns.vue';
import { isAuthenticated } from './services/auth';
import MasterArticles from "./views/MasterArticles.vue";
import MasterArticleDetail from "./views/MasterArticleDetail.vue";
import Assona24h from "./views/Assona24h.vue";
import StockDevices from "./views/StockDevices.vue";
import TicketDetail from "./views/TicketDetail.vue";
import DeliverySlips from "./views/DeliverySlips.vue";

const requireAuth: NavigationGuardWithThis<undefined> = (_to, _from, next) => {
  if (!isAuthenticated()) next({ name: 'home' });
  else next();
};

const routes: RouteRecordRaw[] = [
  { path: '/',               name: 'home',           component: Home },
  { path: '/callback',       name: 'callback',       component: Callback },
  { path: '/dashboard',      name: 'dashboard',      component: Dashboard,      beforeEnter: requireAuth },
  { path: '/servicepartner', name: 'servicepartner', component: Servicepartner, beforeEnter: requireAuth },
  { path: '/masterarticles', name: 'masterarticles', component: MasterArticles, beforeEnter: requireAuth },
  { path: '/errorpatterns',  name: 'errorpatterns',  component: ErrorPatterns,  beforeEnter: requireAuth },
  { path: '/assona24h',      name: 'assona24h',      component: Assona24h,      beforeEnter: requireAuth },
  { path: '/stockdevices',   name: 'stockdevices',   component: StockDevices,   beforeEnter: requireAuth },
  { path: '/deliveryslips',  name: 'deliveryslips',  component: DeliverySlips,  beforeEnter: requireAuth },
  {
    path: '/masterarticle/:id(\\d+)',
    name: 'masterarticle',
    component: MasterArticleDetail,
    beforeEnter: requireAuth,
    props: route => ({ id: Number(route.params.id) }),
  },
  {
    path: '/tickets/:id(\\d+)',
    name: 'ticket-detail',
    component: TicketDetail,
    beforeEnter: requireAuth,
    props: route => ({ id: Number(route.params.id) }),
  },
  { path: '/profile',        name: 'profile',        component: Profile },
  { path: '/:pathMatch(.*)*', redirect: '/' },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
